export const RECEIVE_SEGMENT_LIST = 'RECEIVE_SEGMENT_LIST';
